export default {
    // Status
    open: 'Öppen',
    closed: 'Stängd',
    groomedStatusCurrently: 'Prepareras',
    groomedStatusPassed: 'Preparerat ({{hoursPassed}} h)',
    groomedStatusYesterday: 'Preparerat igår',
    groomedStatusWeekday: 'Preparerat {{weekday}}',
    // Zone
    low: 'Lågzon',
    high: 'Högzon',
    // Difficulty
    veryEasy: 'Mycket lätt',
    veryEasyPlural: 'Mycket lätta',
    easy: 'Lätt',
    easyPlural: 'Lätta',
    medium: 'Medelsvår',
    mediumPlural: 'Medelsvåra',
    hard: 'Svår',
    hardPlural: 'Svåra',
    // Abbreviated weekdays
    abbreviatedMonday: 'mån',
    abbreviatedTuesday: 'tis',
    abbreviatedWednesday: 'ons',
    abbreviatedThursday: 'tor',
    abbreviatedFriday: 'fre',
    abbreviatedSaturday: 'lör',
    abbreviatedSunday: 'sön',
    // Measurements
    elevationAboveSeaLevel: 'm.ö.h.',
    // Misc
    switchDirection: 'Vänd',
    destinationNamePlaceholder: 'Destinationens namn här',
    mapTypeMap: 'Karta',
    mapTypeSatelite: 'Satellit',
    mapTypeThreeD: '3D',
    mapTypeThreeDSatelite: '3D-satellit',
    mapChooserTitle: 'Välj Karta',
    mapChooserStandard: 'Standard',
    mapChooserThreeDStandard: '3D Std.',
    mapChooserThreeDSatellite: '3D Sat.',
    mapChooserSettingsTitle: 'Inställningar',
    mapChooserDirection: 'Riktning',
    mapChooserOpen: 'Karta',
    mapChooserClose: 'Stäng',
    mapFilterTitle: 'Filter',
    mapFilterPathTypes: 'Ledtyper',
    mapFilterPoiTypes: 'POI-typer',
    mapFilterOpen: 'Filter',
    mapFilterClose: 'Stäng',
    mapFilterReset: 'Återställ',
    compositeChildrenDropdownLabel: 'Delsträckor',
    compositeChildLabel: 'Delsträcka',
    compositeChildCount_one: '{{count}} delsträcka',
    compositeChildCount_other: '{{count}} delsträckor',
    expandCompositeTrail: 'Visa delsträckor',
    collapseCompositeTrail: 'Dölj delsträckor',
    compositeParentLink: 'Tillhör: {{name}}',
    selectTrail: 'Välj led',
};